import React, { useEffect, useState } from "react";
import { Container, Form, Button, Alert, ButtonGroup, Spinner } from "react-bootstrap";
import { useAuth } from "../../firebaseContext";
import { useNavigate, useLocation } from "react-router-dom";

export default function UserProfile() {
  const navigate = useNavigate();
  const location = useLocation();
  const email = location.state?.email;
  const { getUserData } = useAuth();

  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    let isMounted = true;
    async function fetchData() {
      setLoading(true);
      try {
        const userDoc = await getUserData(email);
        if (isMounted) {
          setData(userDoc.data());
        }
      } catch (err) {
        setData(null);
      }
      setLoading(false);
    }
    if (email) fetchData();
    return () => { isMounted = false; };
  }, [email, getUserData]);

  return (
    <Container fluid="lg" className="p-2">
      <Button
        variant="primary"
        className="mb-3"
        onClick={() => navigate(-1)}
      >
        Back to Manage Users
      </Button>
      <Alert variant="info">
        You can only view user profile at this moment, but this can be changed in future updates.
      </Alert>
      <Alert variant="warning">
        Details will update once the user logs back in.
      </Alert>
      {loading ? (
        <Spinner animation="border" variant="primary" className="my-4" />
      ) : data ? (
        <Form className="p-2">
          <Form.Group className="mb-3">
            <Form.Label>Email Address</Form.Label>
            <Form.Control type="email" value={data.Email} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>UID</Form.Label>
            <Form.Control type="text" value={data.UID} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Display Name</Form.Label>
            <Form.Control type="text" value={data.Display} disabled />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email Verified?</Form.Label>
            <Form.Control type="text" value={data.Verified ? "Yes" : "No"} disabled />
          </Form.Group>
        </Form>
      ) : (
        <Alert variant="danger">User data not found.</Alert>
      )}
    </Container>
  );
}
